import settings from './middlewares/settings.middleware'
import user from './middlewares/user.middleware'

export default [
    settings,
    user
]